import {
   View,
   Image,
   TouchableOpacity,
   StyleSheet,
   Platform,
   NativeModules,
} from 'react-native';
import React, {useRef} from 'react';
import {
   TRAINING_LIST_BASE_URL,
   isWeb,
   getASLMediaPath,
   isMacOS,
   getASLMacServerPath,
} from '../../utils/utils';
import {useSelector} from 'react-redux';
import {selectCourseId} from '../../redux/slices/CourseIdSlice';
import {selectAslStatus} from '../../redux/slices/AslSlice';
import {Progressbar, MediaIcon} from './components';
import {selectDownloadPreference} from '../../redux/slices/DownloadPreferenceSlice';
const isDesktop = Platform.OS === 'macos' || Platform.OS === 'windows';

const ASLVideoItem = props => {
   const isDownloadPreferenceEnabled = useSelector(selectDownloadPreference);
   const {url, progressALSVideo} = props;

   const courseId = useSelector(selectCourseId);
   const asl = useSelector(selectAslStatus);
   const playerPath = getMediaPath(props.type, courseId, url);
   const audioRef = useRef(null);
   const isMediaPlaying = props.isVideoPlaying;

   const onPress = async () => {
      props.onMediaClicked();
      if (props.type === 'audio') {
         if (asl === 'play') {
            setTimeout(function () {
               stopCall();
            }, 0);
         }
      } else {
         props.showAlsVideo(playerPath);
      }
   };

   function getMediaPath(mediaType, CourseID, urlString) {
      let path = TRAINING_LIST_BASE_URL + courseId + url;
      if (isDesktop && isDownloadPreferenceEnabled === 'true') {
         path = getASLMediaPath(mediaType, CourseID, urlString);
      }
      return path;
   }

   return (
      <View>
         <TouchableOpacity
            onPress={() => onPress()}
            style={[props.style, isWeb ? style.container : {}]}>
            {isMediaPlaying ? (
               <Progressbar
                  progress={progressALSVideo}
                  status={isMediaPlaying}
               />
            ) : (
               <MediaIcon />
            )}
         </TouchableOpacity>
      </View>
   );
};

const style = StyleSheet.create({
   container: {
      //width: 40,
      //height: 40,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
   },
   item: {
      alignItems: 'center',
      alignSelf: 'center',
      justifyContent: 'center',
      height: 20,
      width: 20,
      borderRadius: 16,
      //marginLeft: 8,
   },
   card: {
      width: '90%',
      height: 100,
      backgroundColor: '#FFF',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 10,
      marginBottom: 10,
      elevation: 5,
      zIndex: 999,
   },
});
export default ASLVideoItem;
